import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/door-access/starter-kits/gate-access-starter-kit.png";
import type { Product } from "../../types";
import { starterKits } from "../product-list-groups/starterKits";
import {
  includedAccessories,
  includedHub,
  includedReaders,
  touchPassSupport,
} from "../properties";

export const gateAccessStarterKit: Product = {
  id: "gateAccessStarterKit",
  productTitle: "Gate Access Starter Kit",
  productListGroup: starterKits,
  techspecsPath: [SiteId.TechSpecs, "/unifi/door-access/ua-sk-gate"],
  storePathParts: {
    category: "door-access-starter-kit",
    productSlug: "ua-sk-gate",
  },
  description: "gateAccessStarterKit.description",
  image: { src: image, width: 200, height: 160 },
  propertyValues: [
    {
      propertyId: includedHub.id,
      value: {
        type: "translation",
        value: "gateAccessStarterKit.includedHub",
      },
    },
    {
      propertyId: includedReaders.id,
      value: {
        type: "translation",
        value: "gateAccessStarterKit.includedReaders",
      },
    },
    {
      propertyId: includedAccessories.id,
      value: {
        type: "translation",
        value: "gateAccessStarterKit.includedAccessories",
      },
    },
    {
      propertyId: touchPassSupport.id,
      value: {
        type: "string",
        value: "Apple Wallet\nGoogle Wallet",
      },
    },
  ],
};
